/**
 * Tipos e rótulos do cadastro de instalação com inflamáveis em etapas (issue #366, D12).
 */
import type {
  FlammableActivityType,
  FlammableClassification,
  FlammableInstallationStatus,
} from '../../../../types/flammableInstallation';

export type FlammableWizardStepKey = 'identification' | 'substances' | 'records';

export const FLAMMABLE_WIZARD_STEPS: ReadonlyArray<{ key: FlammableWizardStepKey; label: string }> = [
  { key: 'identification', label: 'Identificação' },
  { key: 'substances', label: 'O que é armazenado' },
  { key: 'records', label: 'Prontuário' },
];

/**
 * Desfecho de guardar o formulário aberto: `incompleto` falta preencher algo (a etapa marca os campos);
 * `recusado` o servidor não aceitou e a etapa já mostra a frase dele.
 */
export type ResultadoDoEnvio = 'enviado' | 'incompleto' | 'recusado';

/** O que uma etapa de lista (produtos, prontuário) oferece a quem a controla. */
export interface StepHandle {
  /** Guarda o formulário aberto, se tiver algo digitado. */
  salvarPendente: () => Promise<ResultadoDoEnvio>;
}

export interface ListStepProps {
  installationId: string;
  /** Quem pode alterar (`flammable_installation.update`); sem isso a etapa só mostra e baixa. */
  canEdit: boolean;
  onDirtyChange: (dirty: boolean) => void;
  onSaved: (message: string) => void;
  /** A etapa 2 avisa a classe que o servidor devolveu, para a etapa 1 reabrir refletindo-a. */
  onClassificationChange?: (classification: FlammableClassification) => void;
}

export interface IdentificationValues {
  /**
   * Empresa dona da instalação. Fica vazia no cadastro novo com empresa ativa (o servidor usa a do
   * contexto) e só é preenchida quando a tela precisa perguntar ou quando a instalação já existe.
   */
  companyId: string;
  departmentId: string;
  name: string;
  tag: string;
  /** Vazio até a pessoa escolher: não há atividade padrão que seja segura. */
  activityType: FlammableActivityType | '';
  activityDescription: string;
  location: string;
  status: FlammableInstallationStatus;
  observations: string;
  /** Vinda do servidor; `null` enquanto a instalação não foi salva (D10: a regra não se repete na tela). */
  classification: FlammableClassification | null;
}

export type IdentificationErrors = Partial<Record<keyof IdentificationValues, string>>;

export const EMPTY_IDENTIFICATION: IdentificationValues = {
  companyId: '',
  departmentId: '',
  name: '',
  tag: '',
  activityType: '',
  activityDescription: '',
  location: '',
  status: 'EM_OPERACAO',
  observations: '',
  classification: null,
};
